<template lang="pug">
  el-dialog(
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-login-cadastro"
    top="5vh"
    @close="resetForm"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  )
    div(slot="title" class='pt-3')
      .pt-1
        Filtro(
          label=" "
          :lista="['Login', 'Cadastrar']"
          :selecionado="filtroSelecao"
          @update="filtroSelecao = $event"
          size="small"
        )
    .login(v-if="filtroSelecao === 'Login'")
      .login-cadastro__form
        .login-cadastro__form__group
          label(for="email") E-mail
          el-input(
            v-model="email"
            placeholder="Digite seu e-mail"
            type="email"
            id="email"
            prefix-icon="el-icon-message"
            prefix-icon-size="16"
            @blur="validateField('email')"
            :class="[validationErrors.email && 'input-error', 'mb-2']"
          )
          label(for="senha") Senha
          el-input(
            v-model="senha"
            placeholder="Digite sua senha"
            type="password"
            id="senha"
            prefix-icon="el-icon-lock"
            prefix-icon-size="16"
          )
        .login-cadastro__form__group__button
          .entrar.w-100.center
            el-button(type="primary" @click="login" class='w-100') Entrar
          .esqueci-senha.w-100.center
            p(class="warning mb-0 underline" @click="setResetSenha(true)") Esqueci minha senha
      .login-cadastro__form__group.pt-5
        el-divider(content-position="left") ou entrar com google
      .login-cadastro__form__group__google
        LoginGoogle
    .cadastro(v-if="filtroSelecao === 'Cadastrar'")
      .login-cadastro__form
        .login-cadastro__form__group
          .box-nome
            .nome
              label(for="nome") Nome <span class="required-asterisk">*</span>
              el-input(v-model="nome" placeholder="Digite seu nome" id="nome" @blur="validateField('nome')" :class="[validationErrors.nome && 'input-error']")
          .box-telefone
            .cnpj
              label(for="cpfCnpj") CPF/CNPJ <span class="required-asterisk">*</span>
              el-input(v-model="cpfCnpj" placeholder="Digite seu CPF ou CNPJ" id="cpfCnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" @blur="validateField('cpfCnpj')" :class=" [validationErrors.cpfCnpj && 'input-error']")
            //- .fixo
            //-   label(for="telefone") Telefone
            //-   el-input(v-model="telefone" placeholder="Digite seu telefone" id="telefone" v-mask="['(##) ####-####', '(##) #####-####']")
            .cel
              label(for="celular") Celular <span class="required-asterisk">*</span>
              el-input(v-model="celular" placeholder="Digite seu celular" id="celular" v-mask="['(##) #####-####', '(##) #####-####']" @blur="validateField('celular')" :class="[validationErrors.celular && 'input-error']")
          .box-nome
            .email
              label(for="email") E-mail <span class="required-asterisk">*</span>
              el-input(v-model="emailCadastro" placeholder="Digite seu e-mail" type="email" id="email" @blur="validateField('emailCadastro')" :class="[validationErrors.emailCadastro && 'input-error']")
            .email
              label(for="email") Confirmar E-mail <span class="required-asterisk">*</span>
              el-input(v-model="confirmarEmail" placeholder="Digite seu e-mail" type="email" id="email" @blur="validateField('confirmarEmail')" :class="[validationErrors.confirmarEmail && 'input-error']")
          //- .box-cidade
            //- .cep
            //-   label(for="cep") CEP
            //-   el-input(v-model="cep" placeholder="Digite seu CEP" id="cep" @blur="buscarEndereco" v-mask="'#####-###'")
            //- .uf
            //-   label(for="uf") UF
            //-   el-select(v-model="uf" placeholder="UF" id="uf")
            //-     el-option(v-for="estado in estados" :key="estado" :label="estado" :value="estado")
            //- .cidade
            //-   label(for="cidade") Cidade
            //-   el-input(v-model="cidade" placeholder="Digite sua cidade" id="cidade")
          //- .box-endereco
            //- .endereco
            //-   label(for="endereco") Endereço
            //-   el-input(v-model="endereco" placeholder="Digite seu endereço" id="endereco")
            //- .bairro
            //-   label(for="bairro") Bairro
            //-   el-input(v-model="bairro" placeholder="Digite seu bairro" id="bairro")
          //- .observacao
          //-   label(for="observacao") Observação
          //-   el-input(v-model="observacao" placeholder="Digite uma observação" id="observacao")
          .box-senha
            //- .linksite
            //-   label(for="linkSite") Link do Site
            //-   el-input(v-model="linkSite" placeholder="Digite o link do seu site" id="linkSite")
            .senha
              label(for="senha") Senha
              el-input(v-model="senhaCadastro" placeholder="Digite sua senha" type="password" id="senha" :show-password="true" @blur="validatePassword")
            .confirmar-senha
              label(for="confirmarSenha") Confirmar Senha
              el-input(v-model="confirmarSenha" placeholder="Confirme sua senha" type="password" id="confirmarSenha" :show-password="true" @blur="validateConfirmPassword" :disabled="!isPasswordValid")
              .senha-mismatch(v-if="validationErrors.confirmarSenha")
                span(style="color: red;") As senhas não conferem
          .password-rules
            span A senha deve conter no mínimo 8 digitos com pelo menos um caractere maiúsculo, um minúsculo, um número e um caractere especial.
          
          .upload-container(
            @click="triggerFileInput"
            @dragover.prevent
            @dragenter.prevent
            @drop.prevent="handleDrop"
          )
            input(type="file" accept=".jpg, .jpeg, .png" @change="handleImageUpload" ref="fileInput")
            .upload-placeholder(v-if="!form.imagem") Clique ou arraste a imagem aqui para fazer o upload
            .image-preview(v-if="form.imagem")
              .image-container
                .img-info
                  img(:src="form.imagem.url" :alt="'Imagem selecionada'")
                  .info-imagem
                    .nome {{ form.imagem.file.name }}
                    .tamanho {{ (form.imagem.file.size / 1024).toFixed(2) }} KB
                .apagar
                  el-button(type="danger" icon="el-icon-delete" circle @click.stop="removeImage")
        .login-cadastro__form__group__button__cadastrar
          el-button(type="primary" :disabled="isButtonDisabled" @click="cadastrar") Cadastrar
          el-button(type="text" @click="dialogVisible = false") Cancelar

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { jwtDecode } from 'jwt-decode'
import LoginGoogle from '../LoginGoogle.vue'
import Filtro from '@/components/Filtro.vue'

export default {
  name: 'ModalPerfil',

  components: {
    LoginGoogle,
    Filtro
  },

  data() {
    return {
      currentDialogWidth: this.calculateDialogWidth(),
      filtroSelecao: 'Login',
      email: '',
      senha: '',
      nome: '',
      emailCadastro: '',
      senhaCadastro: '',
      confirmarSenha: '',
      telefone: '',
      celular: '',
      cpfCnpj: '',
      confirmarEmail: '',
      cep: '',
      uf: '',
      cidade: '',
      endereco: '',
      bairro: '',
      observacao: '',
      linkSite: '',
      estados: [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
      ],
      validationErrors: {
        nome: false,
        emailCadastro: false,
        cpfCnpj: false,
        celular: false,
        senhaCadastro: false,
        confirmarSenha: false
      },
      form: {
        imagem: null
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize());
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize());
  },
  computed: {
    ...mapGetters({
      getModalLogin: 'modais/getLogin'
    }),
    dialogVisible: {
      get() {
        return this.getModalLogin
      },
      set(newValue) {
        this.setModalLogin(newValue)
      }
    },
    dialogWidth() {
      return this.currentDialogWidth;
    },
    isButtonDisabled() {
      return !this.nome || !this.emailCadastro || !this.cpfCnpj || !this.celular || !this.senhaCadastro || !this.confirmarSenha || Object.values(this.validationErrors).some(error => error);
    },
    isPasswordValid() {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      return passwordPattern.test(this.senhaCadastro);
    }
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible) this.filtroSelecao = 'Login'
    },
    filtroSelecao() {
      this.handleResize()
    }
  },

  methods: {
    ...mapActions({
      cadastrarUsuario: 'auth/cadastrarUsuarioPlataforma',
      loginPlataforma: 'auth/loginPlataforma',
      cadastrarImagemUsuario: 'auth/cadastrarImagemUsuario',
    }),
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setModalLogin: 'modais/setLogin',
      setResetSenha: 'modais/setResetSenha',
    }),
    calculateDialogWidth() {
      if (window.innerWidth < 576) return '90%'
      if (this.filtroSelecao === 'Cadastrar') return '490px'
      if (this.filtroSelecao === 'Login') return '490px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },
    async buscarEndereco() {
      const cepSemMascara = this.cep.replace(/\D/g, "")
      if (cepSemMascara.length !== 8) {
        alert("CEP inválido. Deve conter 8 dígitos.")
        return
      }
      try {
        const response = await fetch(`https://viacep.com.br/ws/${this.cep}/json/`)
        if (!response.ok) {
          throw new Error("Erro ao buscar endereço.")
        }
        const data = await response.json()
        if (data.erro) {
          alert("CEP não encontrado.")
          return
        }
        this.uf = data.uf
        this.cidade = data.localidade
        this.endereco = data.logradouro
        this.bairro = data.bairro
      } catch (error) {
        console.error(error)
        alert("Não foi possível buscar o endereço. Tente novamente.")
      }
    },
    login() {
      this.setLoading(true)
      const params = {
        email: this.email,
        senha: this.senha
      }
      this.loginPlataforma(params)
        .then(resp => {
          this.setLoading(false)
          this.setModalLogin(false)
          this.$message({
            message: 'Login realizado com sucesso!',
            type: 'success'
          })
          localStorage.setItem('_linkdrive', `Bearer ${resp.token}`)
          const user = jwtDecode(resp.token)
          localStorage.setItem('user', JSON.stringify(user.data[0][0]))
          setTimeout(() => {
            location.reload()
          }, 1500)
        })
        .catch(err => {
          this.setLoading(false)
          if (err.response.data == 'nenhum cliente encontrado para o e-mail informado') this.$message.error(err.response.data)
          if (err.response.data.message) this.$message.error(err.response.data.message)
          else this.$message.error(err.response.data)
        })
    },
    async cadastrar() {
      if (this.confirmarEmail !== this.emailCadastro) {
        this.$message({
          message: 'A confirmação do e-mail não corresponde ao e-mail informado.',
          type: 'error'
        });
        return;
      }
      this.validatePassword();
      this.validateConfirmPassword();
      if (Object.values(this.validationErrors).some(error => error)) {
        return;
      }
      this.setLoading(true)
      const params = {
        nome: this.nome,
        email: this.emailCadastro,
        senha: this.senhaCadastro,
        telefone: this.telefone,
        celular: this.celular,
        cpfCnpj: this.cpfCnpj,
        cep: this.cep,
        uf: this.uf,
        cidade: this.cidade,
        endereco: this.endereco,
        bairro: this.bairro,
        observacao: this.observacao,
        linksite: this.linkSite
      }

      try {
        const resp = await this.cadastrarUsuario(params);
        if (this.form.imagem) {
          try {
            await this.cadastrarImagemUsuario({ id: resp, imagem: this.form.imagem.file });
          } catch (imageError) {
            this.$message({
              message: 'Cadastro realizado com sucesso, mas não foi possível salvar a imagem.',
              type: 'warning'
            });
            this.resetForm();
            this.filtroSelecao = 'Login';
            this.setLoading(false);
            return
          }
        }
        this.resetForm();
        this.filtroSelecao = 'Login';
        this.setLoading(false);
        this.$message({
          message: 'Cadastro realizado com sucesso!',
          type: 'success'
        });
      } catch (err) {
        this.setLoading(false);
        this.$message.error(err.response.data);
      }
    },
    resetForm() {
      this.email = ''
      this.senha = ''
      this.nome = ''
      this.emailCadastro = ''
      this.senhaCadastro = ''
      this.confirmarSenha = ''
      this.telefone = ''
      this.celular = ''
      this.cpfCnpj = ''
      this.cep = ''
      this.uf = ''
      this.cidade = ''
      this.endereco = ''
      this.bairro = ''
      this.observacao = ''
      this.linkSite = ''
      this.validationErrors = {
        nome: false,
        emailCadastro: false,
        cpfCnpj: false,
        celular: false,
        senhaCadastro: false,
        confirmarSenha: false
      }
      this.form = {
        imagem: null
      }
    },
    validateField(field) {
      if (field === 'emailCadastro') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.validationErrors.emailCadastro = !emailPattern.test(this.emailCadastro);
      } else {
        this.validationErrors[field] = !this[field];
      }
    },
    validatePassword() {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      this.validationErrors.senhaCadastro = !passwordPattern.test(this.senhaCadastro);
    },
    validateConfirmPassword() {
      this.validationErrors.confirmarSenha = this.senhaCadastro !== this.confirmarSenha;
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.imagem = {
          file,
          url: URL.createObjectURL(file)
        };
      }
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) {
        this.form.imagem = {
          file,
          url: URL.createObjectURL(file)
        };
      }
    },
    removeImage() {
      this.form.imagem = null;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    }
  }
}
</script>

<style lang="scss">
.custom-dialog-login-cadastro {
  .el-input__inner {
    border-left: 3px solid #2b80c2 !important;
    border: 1px solid #444 !important;
    &:focus {
      border-color: #2b80c2 !important;
    }
  }

  .el-input__prefix {
    color: #2b80c2 !important;

    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 35%;
      background-color: #bebebe72;
    }
  }
  
  .warning{
    color: #ffffffb0;
    font-weight: 300;
    font-size: 13px;
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
  }

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
      padding: 0 20px 20px 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn {
        top: 19px;

        i {
          font-size: 30px;
        }
      }

      .container-filtro {
        margin: 0;

        .filtro {
          .filtro__busca {
            display: none;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 20px;

      .login {
        .login-cadastro__form {
          .login-cadastro__form__group__button {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-top: 20px;

            .esqueci-senha {
              margin-top: 10px;
            }
          }
        }
      }

      .cadastro {
        .login-cadastro__form {

          .box-nome,
          .box-senha,
          .box-telefone,
          .box-cidade {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            gap: 10px;

            .nome,
            .email {
              width: 100%;
            }

            .senha,
            .confirmar-senha {
              width: 100%;
            }

            .fixo,
            .cel {
              width: 195px;
            }

            .cnpj {
              width: 265px;
            }

            .uf {
              width: 100px;
            }

            .cidade {
              width: 330px;
            }
          }

          .box-endereco {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 10px;
            margin-bottom: 10px;

            .endereco,
            .bairro {
              width: 340px;
            }
          }

          .observacao {
            margin-bottom: 10px;
          }

          .senha-mismatch {
            margin-bottom: -18px;
            font-size: 12px;
          }

          .password-rules {
            border: 1px solid #6a5c46;
            font-size: 12px;
            font-weight: 300;
            color: #7c6b52;
            margin-top: 20px;
            border-radius: 5px;
            padding: 10px;
            box-sizing: border-box;
            word-break: break-word;
          }

          .upload-container {
            border: 1px dashed #626262;
            border-radius: 5px;
            padding: 20px;
            text-align: center;
            cursor: pointer;
            transition: border-color 0.3s ease;
            margin-top: 25px;

            &:hover {
              border-color: #409eff;
            }

            input[type="file"] {
              display: none;
            }

            .upload-placeholder {
              color: #999;
              font-size: 14px;
            }
          }

          .image-preview {
            display: flex;
            justify-content: center;
            margin-top: 25px;

            .image-container {
              position: relative;
              border: 1px solid #d9d9d9;
              border-radius: 5px;
              overflow: hidden;
              transition: transform 0.3s ease, box-shadow 0.3s ease;
              width: 100%;
              height: 115px;
              display: flex;
              justify-content: space-between;

              &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
              }

              .img-info {
                display: flex;

                img {
                  width: 105px;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 5px;
                }

                .info-imagem {
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  padding: 10px;
                  font-size: 12px;
                  color: #666;
                  align-items: flex-start;

                  .nome {
                    font-weight: bold;
                    margin-bottom: 5px;
                    max-width: 420px;
                    word-break: break-word;
                    line-height: 1;
                    text-align: left;
                  }

                  .tamanho {
                    line-height: 1;
                    color: #999;
                  }
                }
              }

              .apagar {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 70px;
                border-left: 1px solid #d9d9d9;
              }
            }
          }
        }

        .login-cadastro__form__group__button__cadastrar {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 25px;
        }
      }
    }

    .el-dialog__footer {
      .dialog-footer {
        display: flex;
        justify-content: center;
        gap: 10px;
      }
    }
  }
}

.required-asterisk {
  color: red;
}

.input-error .el-input__inner {
  border-color: #ff4500 !important;
}

@media (max-width: 576px) {
  .custom-dialog-login-cadastro {
    .el-dialog__body {
      .cadastro {
        .login-cadastro__form {

          .box-nome,
          .box-senha,
          .box-telefone,
          .box-cidade,
          .box-endereco {
            flex-direction: column;

            .nome,
            .email,
            .fixo,
            .cel,
            .cnpj,
            .uf,
            .cep,
            .cidade,
            .endereco,
            .bairro,
            .linksite,
            .senha,
            .confirmar-senha {
              width: 100% !important;
              margin-bottom: 10px;
            }
          }

          .box-cidade {
            .uf {
              display: flex;
              flex-direction: column;
            }
          }
        }
      }
    }
  }

  .upload-container {
    .image-preview {
      .image-container {
        height: 90px !important;

        .img-info {
          img {
            width: 85px !important;
          }

          .info-imagem {
            display: none !important;
          }
        }

        .apagar {
          width: 50px !important;
          border-left: none !important;
          align-items: flex-end !important;
          padding-bottom: 5px !important;

          button {
            width: 35px !important;
            height: 35px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        }

        .image-actions {
          left: 90px !important;
          top: 5px !important;

          .el-radio {
            .el-radio__label {
              font-size: 12px !important;
            }
          }
        }
      }
    }
  }
}
</style>